import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import TabLayout from "../../../helpers/TabLayout";

const ImageLayout = () => {
  const { image } = useLoaderData();
  return (
    <>
      <TabLayout headerLabel={image.imageName || "Image"}>
        <Outlet/>
      </TabLayout>
    </>
  );
};

export default ImageLayout;